import { createSelector } from 'reselect';

const selectServicelinkFloodProductItems = ({ servicelinkFloodProducts }) =>
  servicelinkFloodProducts?.items || [];

export const selectFloodProductOptions = createSelector(selectServicelinkFloodProductItems, items =>
  items.map(({ value, label }) => ({ name: label, value })),
);
